import { DockCapacityIndicator } from "./DockCapacityIndicator";
import { FooterIndicator } from "./FooterIndicator";
import { MainCard } from "./MainCard";
import { Tag } from "./Tag";

export { DailyDeliveryFilters } from "./Filter";
export { DailyDeliveryTable } from "./Table/DailyDeliveryTable";
export { TableEmpty } from "./TableEmpty";

export const Card = Object.assign(MainCard, {
  Tag,
  DockCapacityIndicator,
  FooterIndicator,
});
